import React from 'react';
import { browserHistory } from 'react-router';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Header from './Header';
import Osms from '../images/vopr.png';
import userdata from '../config/jwt_token';
import _ from 'lodash';


const PAYMENTS_REPORT_COLUMNS = [
    {
      Header: 'PR Index',
      key: 'payment_request_id'
    },
    {
        Header: 'Entry Code',
        key: 'entry_code'
    },
    {
        Header: 'Date',
        key: 'date'
    },
    {
        Header: 'Ledger Name',
        key: 'ledger_name'
    },
    {
        Header: 'Payment_Amount',
        key: 'payment_amount'
    },
    {
        Header: 'Narration',
        key: 'narration'
    },
    {
        Header: 'Bill_Link',
        key: 'bill_link'
    },
    {
        Header: 'Expense_FTM',
        key: 'expense_ftm'
    },
    {
        Header: 'Requester Name',
        key: 'requester_name'
    },
    {
      Header: 'Created Date',
      key: 'created_at'
    },
    {
        Header: 'Approver L1',
        key: 'approver1_name'
    },
    {
        Header: 'L1 Approval Date',
        key: 'approverId1_at'
    },
    {
        Header: 'Approver L2',
        key: 'approver2_name'
    },
    {
        Header: 'L2 Approval Date',
        key: 'approverId2_at'
    },
    {
        Header: 'City',
        key: 'city'
    },
    {
        Header: 'Transcation_ID',
        key: 'transaction_id'
    },
    {
        Header: 'Invoice_Date',
        key: 'invoice_date'
    },
    {
        Header: 'Settlement_Type',
        key: 'settlement_type'
    },
    {
        Header: 'Invoice_No.',
        key: 'invoice_no'
    },
    {
        Header: 'PO_No.',
        key: 'po_no'
    },
]

const ACCOUNTING_REPORT_COLUMNS = [
  {
      Header: 'PR Index',
      key: 'payment_request_id'
  },
  {
      Header: 'Ledger_Name_Key',
      key: 'ledger_name_key'
  },
  {
      Header: 'GST_Map_ID',
      key: 'gst_map_id'
  },
  {
      Header: 'Ledger_Type',
      key: 'ledger_type'
  },
  {
      Header: 'Entry Code',
      key: 'entry_code'
  },
  {
      Header: 'Accounting Status',
      key: 'accounting_status'
  },
  {
      Header: 'Accounting Date',
      key: 'accounting_status_date'
  },
  {
      Header: 'Accounted By',
      key: 'accounting_status_by'
  },
  {
      Header: 'Invoice_Date',
      key: 'accounting_date'
  },
  {
      Header: 'Voucher Type',
      key: 'voucher_type'
  },
  {
      Header: 'ZAPS_Ledger_Name',
      key: 'zaps_ledger_name'
  },
  {
      Header: 'ZAPS_GST_Slab',
      key: 'zaps_gst_slab'
  },
  {
      Header: 'ZAPS_Entity_Type',
      key: 'zaps_entity_type'
  },
  {
      Header: 'Ledger Name',
      key: 'ledger_name'
  },
  // {
  //     Header: 'Quantity',
  //     key: 'quantity'
  // },
  // {
  //     Header: 'Rate',
  //     key: 'rate'
  // },
  {
      Header: 'Amount',
      key: 'amount'
  },
  {
      Header: 'Cost Center',
      key: 'cost_center'
  },
  {
      Header: 'Narration',
      key: 'narration'
  },
  {
      Header: 'Bill Link',
      key: 'bill_link'
  },
  {
      Header: 'Amount Recoverable (as per ZAPS)',
      key: 'amount_recoverable'
  },
  {
      Header: 'Amount Recoverable (as per Bill Submission)',
      key: 'billSub_recoverable_amount'
  },
  {
      Header: 'EXP_FTM',
      key: 'exp_ftm'
  },
  {
      Header: 'City',
      key: 'city'
  },
  {
      Header: 'Setup Flag',
      key: 'setup_flag'
  },
  {
      Header: 'Transaction_Date',
      key: 'transaction_date'
  },
  {
      Header: 'Transaction_ID',
      key: 'transaction_id'
  },
  {
      Header: 'Settlement_Type',
      key: 'settlement_type'
  },
  {
      Header: 'Invoice_No.',
      key: 'invoice_no'
  },
  {
      Header: 'GST Availment Type',
      key: 'gst_avail_type'
  },
  {
      Header: 'PO_No.',
      key: 'po_no'
  },
  {
      Header: 'Bill_Submission_Date',
      key: 'payment_request_date'
  },
  {
    Header: 'Invoice Due Date',
    key: 'invoice_due_date'
  },
  {
    Header: 'L1 Approval Date',
    key: 'approver1_date'
  }
]

const BILL_SUBMISSION_REPORT_COLUMNS = [
  {
    Header: 'PR Index',
    key: 'payment_request_id'
  },
  {
    Header: 'Bill Submission Id',
    key: 'bs_Id'
  },
  {
    Header: 'Bill Submission Requester',
    key: 'bs_requesterEmail'
  },
  {
    Header: 'City',
    key: 'city'
  },
  {
    Header: 'Bill Submission Date',
    key: 'bill_submissions_date'
  },
  {
    Header: 'Type of Transaction',
    key: 'type_of_transaction'
  },
  {
    Header: 'Business Unit',
    key: 'business_unit'
  },
  {
    Header: 'Bill-Sub L1 Approver',
    key: 'L1_approver'
  },
  {
    Header: 'Bill-Sub L1 Approver Date',
    key: 'L1_approver_date'
  },
  {
    Header: 'Bill-Sub L1 Approver Comment',
    key: 'L1_approver_comment'
  },
  {
    Header: 'Bill-Sub L2 Approver',
    key: 'L2_approver'
  },
  {
    Header: 'Bill-Sub L2 Approver Date',
    key: 'L2_approver_date'
  },
  {
    Header: 'Bill-Sub L2 Approver Comment',
    key: 'L2_approver_comment'
  },
  {
    Header: 'Bill-Sub L3 Approver',
    key: 'L3_approver'
  },
  {
    Header: 'Bill-Sub L3 Approver Date',
    key: 'L3_approver_date'
  },
  {
    Header: 'Bill-Sub L3 Approver Comment',
    key: 'L3_approver_comment'
  },
  {
    Header: 'Bill-Sub L4 Approver',
    key: 'L4_approver'
  },
  {
    Header: 'Bill-Sub L4 Approver Date',
    key: 'L4_approver_date'
  },
  {
    Header: 'Bill-Sub L4 Approver Comment',
    key: 'L4_approver_comment'
  },
  {
    Header: 'Vendor name',
    key: 'name'
  },
  {
    Header: 'Payment Request Date',
    key: 'created_at'
  },
  {
    Header: 'Invoice Amount',
    key: 'total_payable_amount'
  },
  {
    Header: 'Amount Recoverable (as per ZAPS)',
    key: 'amount_recoverable'
  },
  {
    Header: 'Amount Recoverable (as per Bill Submission)',
    key: 'billSub_recoverable_amount'
  },
  {
    Header: 'Invoice Date',
    key: 'date_of_invoice'
  },
  {
    Header: 'Invoice Due Date',
    key: 'invoice_due_date'
  },
  {
    Header: 'Invoice Number',
    key: 'invoice_number'
  },
  {
    Header: 'Advance Paid',
    key: 'advance_paid'
  },
  {
    Header: 'Invoice Copy Link',
    key: 'invoice_soft_copy_link'
  },
  {
    Header: 'Supporting Document',
    key: 'supporting_document_link'
  },
  {
    Header: 'Zaps L1 Approver',
    key: 'zaps_approver_l1_name'
  },
  {
    Header: 'Zaps L1 Approver Date',
    key: 'approverId1_at'
  },
  {
    Header: 'Zaps L2 Approver',
    key: 'zaps_approver_l2_name'
  },
  {
    Header: 'Zaps L2 Approver Date',
    key: 'approverId2_at'
  },
  {
    Header: 'Transaction Status',
    key: 'status'
  },
  {
    Header: 'City Finance Remarks',
    key: 'city_finance_remarks'
  },
  {
    Header: 'Zaps L1 Approver Remarks',
    key: 'city_head_remarks'
  },
  {
    Header: 'Zaps L2 Approver Remarks',
    key: 'central_finance_remarks'
  },
  {
    Header: 'Accounting Status',
    key: 'accounting_status'
  },
  {
    Header: 'Accounting Date',
    key: 'accounting_status_date'
  },
  {
    Header: 'Accounted By',
    key: 'accounting_status_by'
  },
  {
    key : 'hold_comment',
    Header: 'Hold Comment'
  },
  {
    key : 'unhold_comment',
    Header: 'Unhold Comment'
  },
  {
    key : 'hold_unhold_by',
    Header: 'Hold/Unhold By'
  },
  {
    key : 'hold_unhold_date',
    Header: 'Hold/Unhold Date'
  },
  {
    Header: 'Payment Date',
    key: 'transaction_date'
  },
  {
    Header: 'UTR Number',
    key: 'transaction_id'
  },
  {
    Header: 'Beneficiary Account Number',
    key: 'beneficiary_account_number'
  },
  {
    Header: 'Beneficiary Name',
    key: 'beneficiary_name'
  },
  {
    Header: 'Deleted At',
    key: 'deleted_at'
  },
  {
    Header: 'Deleted By',
    key: 'deleted_by'
  }
]

const LEDGER_BASED_BILLING_REPORT_COLUMNS = [
  {
    Header: 'Payment Request ID',
    key: 'payment_request_id'
  },
  {
    Header: 'Property Name',
    key: 'property_name'
  },
  {
    Header: 'Vendor Name',
    key: 'vendor_name'
  },
  {
    Header: 'Inv No.',
    key: 'invoice_number'
  },
  {
    Header: 'Inv Date',
    key: 'date_of_invoice'
  },
  {
    Header: 'Status',
    key: 'status'
  },
  {
    Header: 'Billing Period',
    key: 'billing_period'
  },
  {
    Header: 'Expenditure Start Date',
    key: 'expenditure_start_date'
  },
  {
    Header: 'Expenditure End Date',
    key: 'expenditure_end_date'
  },
  {
    Header: 'Business Unit',
    key: 'business_unit'
  },
  {
    Header: 'Bill Type',
    key: 'bill_type'
  },
  {
    Header: 'Ledger Name',
    key: 'ledger_name'
  },
  {
    Header: 'Basic',
    key: 'base_amount'
  },
  {
    Header: 'CGST',
    key: 'cgst'
  },
  {
    Header: 'SGST',
    key: 'sgst'
  },
  {
    Header: 'IGST',
    key: 'igst'
  },
  {
    Header: 'TDS',
    key: 'tds'
  },
  {
    Header: 'Net Payable',
    key: 'net_payable'
  },
  {
    Header: 'CGST RCM Input',
    key: 'cgst_rcm_input'
  },
  {
    Header: 'SGST RCM Input',
    key: 'sgst_rcm_input'
  },
  {
      Header: 'IGST RCM Input',
      key: 'igst_rcm_input'
  },
  {
      Header: 'CGST RCM Output',
      key: 'cgst_rcm_output'
  },
  {
      Header: 'SGST RCM Output',
      key: 'sgst_rcm_output'
  },
  {
      Header: 'IGST RCM Output',
      key: 'igst_rcm_output'
  },
  {
      Header: 'TDS %',
      key: 'tds_percentage'
  },
  {
      Header: 'GST %',
      key: 'gst'
  },
  {
    Header: 'GST Catagory',
    key: 'gst_category'
  },
  {
      Header: 'Discount',
      key: 'discount'
  },
  {
      Header: 'Deductions',
      key: 'deductions'
  },
  {
      Header: 'Round-off',
      key: 'round_off'
  },
  {
      Header: 'TDS Applicable Amount',
      key: 'tds_applicable'
  },
  {
      Header: 'Bill Link',
      key: 'bill_link'
  },
  {
      Header: 'Narration',
      key: 'narration'
  },
  {
      Header: 'Section',
      key: 'tds_section'
  },
]

export const getPaymentsReportCSVData = async (rawData) => {
  let data = rawData.map((cur)=>({
    'PR Index': cur.payment_request_id,
    'Entry Code' : cur.entry_code,    
    'Date' : cur.date,    
    'Ledger Name' : cur.ledger_name,    
    'Payment_Amount' : cur.payment_amount,    
    'Narration' : cur.narration,    
    'Bill_Link' : cur.bill_link,      
    'Expense_FTM' : cur.expense_ftm,    
    'Requester Name' : cur.requester_name,
    'Created Date' : cur.created_at,
    'Approver L1' : cur.approver1_name,
    'L1 Approval Date' : cur.approverId1_at,
    'Approver L2' : cur.approver2_name,
    'L2 Approval Date' : cur.approverId2_at,
    'City' : cur.city,    
    'Transcation_ID' : cur.transaction_id,    
    'Invoice_Date' : cur.invoice_date,
    'Settlement_Type' : cur.settlement_type,    
    'Invoice_No.' : cur.invoice_no,    
    'PO_No.' : cur.po_no,
  }))
  let headers = _.map(PAYMENTS_REPORT_COLUMNS,'Header');

  return {
    data: data,
    headers: headers,
    filename: 'ZAPS_Payments_Report'
  }
}

export const getAccountingReportCSVData = async (rawData, filters = {}) => {
  let data = rawData.map((cur)=> ({
    'PR Index' : cur.payment_request_id,
    'Ledger_Name_Key' : cur.ledger_name_key,
    'GST_Map_ID' : cur.gst_map_id,
    'Ledger_Type' : cur.ledger_type,
    'Entry Code' : cur.entry_code,
    'Accounting Status' : cur.accounting_status,
    'Accounting Date' : cur.accounting_status_date,
    'Accounted By' : cur.accounting_status_by,
    'Invoice_Date' : cur.accounting_date,
    'Voucher Type' : cur.voucher_type,
    'ZAPS_Ledger_Name' : cur.zaps_ledger_name,
    'ZAPS_GST_Slab' : cur.zaps_gst_slab,
    'ZAPS_Entity_Type' : cur.zaps_entity_type,
    'Ledger Name' : cur.ledger_name,
    // 'Quantity': cur.quantity,
    // 'Rate': cur.rate,
    'Amount' : cur.amount,
    'Cost Center' : cur.cost_center,
    'Narration' : cur.narration,
    'Bill Link' : cur.bill_link,
    'Amount Recoverable (as per ZAPS)' : cur.amount_recoverable,
    'Amount Recoverable (as per Bill Submission)' : cur.billSub_recoverable_amount,
    'EXP_FTM' : cur.exp_ftm,
    'City' : cur.city,
    'Setup Flag' : cur.setup_flag,
    'Transaction_Date' : cur.transaction_date,
    'Transaction_ID' : cur.transaction_id,
    'Settlement_Type' : cur.settlement_type,
    'Invoice_No.' : cur.invoice_no,
    'GST Availment Type' : cur.gst_avail_type,
    'PO_No.' : cur.po_no,
    'Bill_Submission_Date' : cur.payment_request_date,
    'Invoice Due Date' : cur.invoice_due_date,
    'L1 Approval Date' : cur.approver1_date
  }))
  let headers = _.map(ACCOUNTING_REPORT_COLUMNS,'Header');

  return {
    data: data,
    headers: headers,
    filename: (filters.from_date && filters.to_date) ? `ZAPS_Accounting_Report_${filters.from_date}-to-${filters.to_date}` : 'ZAPS_Accounting_Report'
  }
}

export const getBillSubmissionReportCSVData = async (rawData) => {
  let data = rawData.map((cur)=>({
    'PR Index' : cur.payment_request_id,
    'Bill Submission Id': cur.bs_Id,
    'Bill Submission Requester': cur.bs_requesterEmail,
    'City' : cur.city,
    'Bill Submission Date' : cur.bill_submissions_date,
    'Type of Transaction' : cur.type_of_transaction,
    'Business Unit' : cur.business_unit,
    'Bill-Sub L1 Approver Date' : cur.L1_approver_date,
    'Bill-Sub L1 Approver' : cur.L1_approver,
    'Bill-Sub L1 Approver Comment' : cur.L1_approver_comment,
    'Bill-Sub L2 Approver Date' : cur.L2_approver_date,
    'Bill-Sub L2 Approver' : cur.L2_approver,
    'Bill-Sub L2 Approver Comment' : cur.L2_approver_comment,
    'Bill-Sub L3 Approver Date' : cur.L3_approver_date,
    'Bill-Sub L3 Approver' : cur.L3_approver,
    'Bill-Sub L3 Approver Comment' : cur.L3_approver_comment,
    'Bill-Sub L4 Approver Date' : cur.L4_approver_date,
    'Bill-Sub L4 Approver' : cur.L4_approver,
    'Bill-Sub L4 Approver Comment' : cur.L4_approver_comment,
    'Vendor name' : cur.name,
    'Payment Request Date' : cur.created_at,
    'Invoice Amount': cur.total_payable_amount,
    'Amount Recoverable (as per ZAPS)' : cur.amount_recoverable,
    'Amount Recoverable (as per Bill Submission)' : cur.billSub_recoverable_amount,
    'Invoice Date' : cur.date_of_invoice,
    'Invoice Due Date' : cur.invoice_due_date,
    'Invoice Number' : cur.invoice_number,
    'Advance Paid' : cur.advance_paid,
    'Invoice Copy Link' : cur.invoice_soft_copy_link,
    'Supporting Document' : cur.supporting_document_link,
    'Zaps L1 Approver' : cur.zaps_approver_l1_name,
    'Zaps L1 Approver Date' : cur.approverId1_at,
    'Zaps L2 Approver' : cur.zaps_approver_l2_name,
    'Zaps L2 Approver Date' : cur.approverId2_at,
    'Transaction Status' : cur.status,
    'City Finance Remarks' : cur.city_finance_remarks,
    'Zaps L1 Approver Remarks' : cur.city_head_remarks,
    'Zaps L2 Approver Remarks' : cur.central_finance_remarks,
    'Accounting Status' : cur.accounting_status,
    'Accounting Date' : cur.accounting_status_date,
    'Accounted By' : cur.accounting_status_by,
    'Hold Comment' : cur.hold_comment,
    'Unhold Comment' : cur.unhold_comment,
    'Hold/Unhold By' : cur.hold_unhold_by,
    'Hold/Unhold Date' : cur.hold_unhold_date,
    'Payment Date' : cur.transaction_date,
    'UTR Number' : cur.transaction_id,
    'Beneficiary Account Number' : cur.beneficiary_account_number,
    'Beneficiary Name' : cur.beneficiary_name,
    'Deleted At' : cur.deleted_at,
    'Deleted By' : cur.deleted_by
  }));
  let headers = _.map(BILL_SUBMISSION_REPORT_COLUMNS,'Header');

  return {
    data: data,
    headers: headers,
    filename: 'ZAPS_Bill_Submission_Report'
  }
}

export const getLedgerBasedBillingReportCSVData = async (rawData) => {
  let data = rawData.map((cur) => ({
    'Payment Request ID': cur.payment_request_id,
    'Property Name': cur.property_name,
    'Vendor Name': cur.vendor_name,
    'Inv No.': cur.invoice_number,
    'Inv Date': cur.date_of_invoice,
    'Status': cur.status,
    'Billing Period': cur.billing_period,
    'Expenditure Start Date': cur.expenditure_start_date,
    'Expenditure End Date': cur.expenditure_end_date,
    'Business Unit': cur.business_unit,
    'Bill Type': cur.bill_type,
    'Ledger Name': cur.ledger_name,
    'Basic': cur.base_amount,
    'CGST': cur.cgst,
    'SGST': cur.sgst,
    'IGST': cur.igst,
    'TDS': cur.tds,
    'Net Payable': cur.net_payable,
    'CGST RCM Input': cur.cgst_rcm_input,
    'SGST RCM Input': cur.sgst_rcm_input,
    'IGST RCM Input': cur.igst_rcm_input,
    'CGST RCM Output': cur.cgst_rcm_output,
    'SGST RCM Output': cur.sgst_rcm_output,
    'IGST RCM Output': cur.igst_rcm_output,
    'TDS %': cur.tds_percentage,
    'GST %': cur.gst,
    'GST Catagory': cur.gst_category,
    'Discount': cur.discount,
    'Deductions': cur.deductions,
    'Round-off': cur.round_off,
    'TDS Applicable Amount': cur.tds_applicable,
    'Bill Link': cur.bill_link,
    'Narration': cur.narration,
    'Section': cur.tds_section
  }));
  let headers = _.map(LEDGER_BASED_BILLING_REPORT_COLUMNS, 'Header');

  return {
    data: data,
    headers: headers,
    filename: 'ZAPS_Provision_Report'
  }
}

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      errorUsername: '',
      errorPassword: '',
      roleSelected: '',
      hideType: 'block',
      invalidLogin: false,
      isLogged: false,
      centralfinancefieldStyle: { width: '220px', textAlign: 'center' },
      cityfinancefieldStyle: { width: '220px', textAlign: 'center' },
      disablePaymentsReport: true,
      disableAccountingReport: true,
      disableTallyExcelUpload: true,
      disableCostOwnerCenterReport: true,
      dialogOpen: false,
      paymentsReportColumns: PAYMENTS_REPORT_COLUMNS,
      accountingReportColumns: ACCOUNTING_REPORT_COLUMNS,
      billSubmissionReportColumns: BILL_SUBMISSION_REPORT_COLUMNS,
      ledgerBasedBillingReportColumns: LEDGER_BASED_BILLING_REPORT_COLUMNS,
    }
  }
  componentWillMount() {
    if (userdata) {
      let role = userdata.role
      let state = this.state
      if (role.indexOf('Central Finance') !== -1) {
        state.disablePaymentsReport = false
        state.disableAccountingReport = false
      }
      if (role === 'root' || role === 'Super Central Finance' || role === 'Report Viewer') {
        state.disablePaymentsReport = false
        state.disableAccountingReport = false
        state.disableTallyExcelUpload = false
        state.disableCostOwnerCenterReport = false
      }
      if (role === 'City Head') {
        state.disableAccountingReport = false
      }
      if (role === 'City Finance') {
        state.disableTallyExcelUpload = false
      }
      if (role === 'Cost Report Viewer') {
        state.disableCostOwnerCenterReport = false
      }
      this.setState({ ...state, loadOptions: true })
    }
    else {
      browserHistory.push('/')
      return
    }
  }
  handleClose() {
    this.setState({ dialogOpen: false })
  }

  ImageLoaded() {
    this.setState({ ImageLoaded: true })
  }
  handleNavigation(value) {
    switch (value) {
      case 'paymentsReport': {
        if (!this.state.disablePaymentsReport)
          browserHistory.push({pathname: '/payment/paymentsReport', state: {paymentsReportColumns: this.state.paymentsReportColumns, accountingReportColumns: this.state.accountingReportColumns, billSubmissionReportColumns: this.state.billSubmissionReportColumns}})
        else {
          this.setState({ dialogOpen: true })
        }
        return
      }
      case 'accountingReport': {
        if (!this.state.disableAccountingReport)
          browserHistory.push({pathname: '/payment/accountingReport', state: {paymentsReportColumns: this.state.paymentsReportColumns, accountingReportColumns: this.state.accountingReportColumns, billSubmissionReportColumns: this.state.billSubmissionReportColumns}})
        else {
          this.setState({ dialogOpen: true })
        }
        return
      }
      case 'billSubmissionReport': {
        browserHistory.push({pathname: '/payment/billSubmissionReport', state: {paymentsReportColumns: this.state.paymentsReportColumns, accountingReportColumns: this.state.accountingReportColumns, billSubmissionReportColumns: this.state.billSubmissionReportColumns}})
        return
      }

      case 'provisionReport': {
        browserHistory.push({
          pathname: '/payment/provisionReport', 
          state: {
            paymentsReportColumns: this.state.paymentsReportColumns, 
            accountingReportColumns: this.state.accountingReportColumns, billSubmissionReportColumns: this.state.billSubmissionReportColumns,
            ledgerBasedBillingReportColumns: this.state.ledgerBasedBillingReportColumns
          }
        })
        return
      }
      case 'costOwnerCenterReport': {
        browserHistory.push({ pathname: '/payment/costOwnerCenterReport' })
        return
      }

      case 'tallyExcelUpload': {
        if (!this.state.disableTallyExcelUpload)
          browserHistory.push({ pathname: '/payment/tally-excel-upload' })
        else {
          this.setState({ dialogOpen: true })
        }
        return
      }
    }
  }
  render() {
    const REPORT_CARDS = [
      {
        key: 'paymentsReport',
        icon: '💳',
        title: 'Payments Report',
        desc: 'Full ledger of all payment requests and transactions',
        disabled: this.state.disablePaymentsReport,
      },
      {
        key: 'accountingReport',
        icon: '📊',
        title: 'Accounting Report',
        desc: 'GST mapping, voucher types and accounting status details',
        disabled: this.state.disableAccountingReport,
      },
      {
        key: 'billSubmissionReport',
        icon: '🧾',
        title: 'Bill Submission Report',
        desc: 'Track bill submissions, approvals and invoice status',
        disabled: false,
      },
      {
        key: 'provisionReport',
        icon: '📋',
        title: 'Provision Report',
        desc: 'Ledger-based billing breakdown with TDS and GST details',
        disabled: false,
      },
      {
        key: 'costOwnerCenterReport',
        icon: '🏢',
        title: 'Cost Owner / Center Report',
        desc: 'Cost center allocation and ownership analytics',
        disabled: this.state.disableCostOwnerCenterReport,
      },
      {
        key: 'tallyExcelUpload',
        icon: '📤',
        title: 'Tally Excel Upload',
        desc: 'Upload and sync Tally-compatible Excel exports',
        disabled: this.state.disableTallyExcelUpload,
      },
    ]

    return (
      <div>
        <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">Reports</h2>
              <p className="zaps-page-subtitle">Zolo Accounting &amp; Payment System — select a report to download or view</p>
            </div>
          </div>

          {this.state.loadOptions && (
            <div className="zaps-report-grid">
              {REPORT_CARDS.map(card => (
                <div
                  key={card.key}
                  className={"zaps-report-card" + (card.disabled ? " zaps-report-disabled" : "")}
                  onClick={() => !card.disabled && this.handleNavigation(card.key)}
                  role="button"
                  tabIndex={card.disabled ? -1 : 0}
                  onKeyDown={e => e.key === "Enter" && !card.disabled && this.handleNavigation(card.key)}
                >
                  <div className="zaps-report-card-icon">{card.icon}</div>
                  <p className="zaps-report-card-title">{card.title}</p>
                  <p className="zaps-report-card-desc">{card.desc}</p>
                  <span className="zaps-report-card-cta">
                    {card.disabled ? "Access restricted" : "Open report →"}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        <Dialog
          open={this.state.dialogOpen}
          onClose={this.handleClose.bind(this)}
          aria-labelledby="access-dialog-title"
        >
          <DialogContent>
            <p style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>Access Restricted</p>
            <p style={{ margin: "8px 0 0", fontSize: 13, color: "#64748b" }}>
              You don't have access to this report. Please contact{" "}
              <a href="mailto:product@zolostays.com">product@zolostays.com</a>.
            </p>
          </DialogContent>
          <DialogActions>
            <button
              onClick={this.handleClose.bind(this)}
              style={{ background: "var(--primary)", color: "#fff", border: "none", borderRadius: "6px", padding: "8px 20px", cursor: "pointer", fontWeight: 600, fontSize: 13 }}
            >
              OK
            </button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}


export default Reports



// WEBPACK FOOTER //
// ./src/components/Reports.js